import React from 'react';
import PropTypes from 'prop-types';
import { h5PageCount } from 'ThreeTerminal_utils';
import Content from './content';

class Layout extends React.PureComponent {
    static propTypes = { content: PropTypes.object };

    async componentDidMount() {
        // 上报首屏时间
        if (window && window.BJ_REPORT) window.BJ_REPORT.firstScreen();
        const { cid, type } = this.props.content;

        /**
         * 页面统计埋点
         **/
        h5PageCount([
            {
                behavior: 'page',
                type: type === 'source' ? 'main_tag' : 'vaminfo',
                other: {
                    id: type === 'source' ? cid : `vp_${cid}`,
                    ref: encodeURIComponent(document.referrer),
                    url: encodeURIComponent(location.href),
                    tag: 'home',
                    cid,
                },
            },
        ]);
    }

    render() {
        console.log(this.props.content);

        return <Content content={this.props.content} />;
    }
}

export default Layout;
